module.exports = __webpack_public_path__ + "img/happy.b8d2d456.png";